import React from 'react';
import PropTypes from 'prop-types';
import { Iframe } from './URLFrame.style';

const URLFrame = ({ url }) => (<Iframe src={url} />);
URLFrame.propTypes = {
  url: PropTypes.string.isRequired,
};
export default URLFrame;
